// external uri regexp
export const EXTERNAL_URI = /^(https?:|mailto:|tel:)/i

// email regexp
export const EMAIL = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}/

// number regexp
export const NUMBER = /^\d+(\.\d+)?$/

// hour regexp, range between 0.01 to 23.99
export const HOUR_REGEXP = /^(0\.(0[1-9]|[1-9]\d?)|(0?[1-9]|1\d|2[0-3])(\.\d{1,2})?)$/
